import { ft } from './utils';

const LABELS = {
  applicant: ft('i18n_common_applicant', '申请人'),
  applicationDepartment: ft('i18n_common_application_department', '申请部门'),
  companyNumber: ft('i18n_common_company_number', '公司编码'),
  costCenter: ft('i18n_common_cost_center', '成本中心'),
  deliveryNotice: ft('i18n_common_delivery_notice', '送货通知单'),
  deliveryNoticeOrder: ft('i18n_common_delivery_notice_order', '送货通知订单'),
  expectedSupplier: ft('i18n_common_expected_supplier', '期望供应商'),
  materialGroup: ft('i18n_common_material_group', '物料组'),
  materials: ft('i18n_common_materials', '物料'),
  organization: ft('i18n_common_organization', '组织'),
  outsourcingOrderNumber: ft('i18n_common_outsourcing_order_number', '外协订单号'),
  outsourcingSupplier: ft('i18n_common_outsourcing_supplier', '外协供应商'),
  priceInformationRecordNumber: ft('i18n_common_price_information_record_number', '价格信息记录号'),
  principal: ft('i18n_common_principal', '负责人'),
  processingPlant: ft('i18n_common_processing_plant', '加工厂'),
  purchaseManager: ft('i18n_common_purchase_manager', '采购负责人'),
  purchasePlanner: ft('i18n_common_purchase_planner', '采购计划员'),
  purchasingFactory: ft('i18n_common_purchasing_factory', '采购工厂'),
  purchasingGroup: ft('i18n_common_purchasing_group', '采购组'),
  purchasingOrganization: ft('i18n_common_purchasing_organization', '采购组织'),
  receipt: ft('i18n_common_goods_receipt', '收货单'),
  receiver: ft('i18n_common_receiver', '收货人'),
  receivingSupplier: ft('i18n_common_receiving_supplier', '收货供应商'),
  reconciliations: ft('i18n_common_reconciliations', '对账单'),
  salesManager: ft('i18n_common_sales_manager', '销售负责人'),
  supplier: ft('i18n_common_supplier', '供应商')
};

const popList = [
  {
    label: LABELS.materials,
    prop: 'materialNumber',
    url: '/masterdata/#/v2/view/',
    component: 'fast2-select-material',
    func: 'selectedRowMaterails',
    // params: ['materialNumber', 'factory']
    option: {
      isOption: true,
      dataValueProp: 'materialNumber',
      dataNameProp: 'materialName',
      valueProp: 'materialNumber',
      nameProp: 'materialName',
      aliasProps: ['factory']
    }
  },
  {
    label: LABELS.purchasingGroup,
    prop: 'purchaseGroup',
    url: '/masterdata/material/#/masterdata/view/',
    component: 'fast2-select-purchase-group',
    func: 'saveSelected',
    params: ['purchaseGroup', 'purchaseGroupDesc', 'orgId', 'orgDesc'],
    option: {
      isOption: true,
      dataValueProp: 'orgId',
      dataNameProp: 'orgDesc',
      valueProp: 'purchaseGroup',
      nameProp: 'purchaseGroupDesc',
      aliasProps: []
    }
  },
  {
    label: LABELS.purchasingGroup,
    prop: 'purchaseGroupCode',
    url: '/masterdata/material/#/masterdata/view/',
    component: 'fast2-select-purchase-group',
    func: 'saveSelected',
    params: ['purchaseGroupCode', 'purchaseGroupDesc', 'orgId', 'orgDesc', 'purchaseGroupName']
  },
  {
    label: LABELS.purchasingOrganization,
    prop: 'purchaseOrganization',
    url: '/masterdata/material/#/masterdata/view/',
    component: 'fast2-select-purchase-organization',
    func: 'saveSelected',
    params: [
      'purchaseOrganization',
      'purchaseOrganizationDesc',
      'orgId',
      'orgDesc',
      'purchaseOrganizationName'
    ],
    option: {
      isOption: true,
      dataValueProp: 'orgId',
      dataNameProp: 'orgDesc',
      valueProp: 'purchaseOrganization',
      nameProp: 'purchaseOrganizationName',
      aliasProps: ['purchaseOrganizationDesc']
    }
  },
  {
    label: LABELS.purchasingOrganization,
    prop: 'organizationCode',
    url: '/masterdata/material/#/masterdata/view/',
    component: 'fast2-select-purchase-organization',
    func: 'saveSelected',
    params: [
      'organizationCode',
      'purchaseOrganizationDesc',
      'orgId',
      'orgDesc',
      'purchaseOrganizationName'
    ]
  },
  {
    label: LABELS.expectedSupplier,
    prop: 'expectSupplierEls',
    url: '/masterdata/material/#/masterdata/view/',
    component: 'fast2-select-supplier',
    func: 'saveSelected',
    params: ['expectSupplierEls', 'expectSupplierName', 'toElsAccount', 'toElsAccountName'],
    option: {
      isOption: true,
      dataValueProp: 'toElsAccount',
      dataNameProp: 'toElsAccountName',
      valueProp: 'expectSupplierEls',
      nameProp: 'expectSupplierName',
      aliasProps: []
    }
  },
  {
    label: LABELS.receivingSupplier,
    prop: 'deliverySupplierNumber',
    url: '/masterdata/material/#/masterdata/view/',
    component: 'fast2-select-supplier',
    func: 'saveSelected',
    params: ['deliverySupplierNumber', 'deliverySupplierName', 'toElsAccount', 'toElsAccountName']
  },

  {
    label: LABELS.companyNumber,
    prop: 'companyCode',
    url: '/masterdata/material/#/masterdata/view/',
    component: 'fast2-select-company',
    func: 'saveSelected',
    params: ['companyCode', 'companyName', 'orgId', 'orgDesc'],
    option: {
      isOption: true,
      dataValueProp: 'orgId',
      dataNameProp: 'orgDesc',
      valueProp: 'companyCode',
      nameProp: 'companyName',
      aliasProps: ['companyDesc']
    }
  },
  {
    label: LABELS.costCenter,
    prop: 'costCenterCode',
    url: '/masterdata/material/#/masterdata/view/',
    component: 'fast2-select-cost-center',
    func: 'saveSelected',
    params: ['costCenterCode', 'costCenterDesc', 'costCenterCode', 'costCenterDesc']
  },
  {
    label: LABELS.costCenter,
    prop: 'costCenter',
    url: '/masterdata/material/#/masterdata/view/',
    component: 'fast2-select-cost-center',
    func: 'saveSelected',
    params: ['costCenter', 'costCenterDesc', 'costCenterCode', 'costCenterCode'],
    option: {
      isOption: true,
      dataValueProp: 'costCenterCode',
      dataNameProp: 'costCenterCode',
      valueProp: 'costCenter',
      nameProp: 'costCenterDesc',
      aliasProps: []
    }
  },
  {
    label: LABELS.materialGroup,
    prop: 'materialGroup',
    url: '/masterdata/material/#/masterdata/view/',
    component: 'fast2-select-purchase-organization',
    func: 'saveSelected',
    params: ['materialGroup', 'materialGroupName', 'orgId', 'orgDesc']
  },
  {
    label: LABELS.supplier,
    prop: 'toElsAccount',
    url: '/masterdata/material/#/masterdata/view/',
    component: 'fast2-select-supplier',
    func: 'saveSelected',
    params: ['toElsAccount', 'toElsAccountName', 'toElsAccount', 'toElsAccountName', 'supplierName']
  },
  {
    label: LABELS.supplier,
    prop: 'supplierAccount',
    url: '/masterdata/material/#/masterdata/view/',
    component: 'fast2-select-supplier',
    func: 'saveSelected',
    params: [
      'supplierAccount',
      'toElsAccountName',
      'supplierAccount',
      'toElsAccountName',
      'supplierName'
    ],
    option: {
      isOption: true,
      dataValueProp: 'toElsAccount',
      dataNameProp: 'toElsAccountName',
      valueProp: 'supplierAccount',
      nameProp: 'supplierName',
      aliasProps: ['toElsAccountName']
    }
  },
  {
    label: LABELS.outsourcingSupplier,
    prop: 'outSaleElsAccount',
    url: '/masterdata/material/#/masterdata/view/',
    component: 'fast2-select-supplier',
    func: 'saveSelected',
    params: [
      'outSaleElsAccount',
      'outSaleElsAccountName',
      'toElsAccount',
      'toElsAccountName',
      'supplierName'
    ]
  },
  {
    label: LABELS.purchasePlanner,
    prop: 'purchasePlaner',
    url: '/masterdata/material/#/masterdata/view/',
    component: 'fast2-select-employee',
    func: 'saveSelected',
    params: ['purchasePlaner', 'purchasePlanerName', 'elsSubAccount', 'name']
  },
  {
    label: LABELS.purchaseManager,
    prop: 'purchasePerson',
    url: '/masterdata/material/#/masterdata/view/',
    component: 'fast2-select-purchase-leader',
    func: 'saveSelected',
    params: ['purchasePerson', 'purchasePersonName', 'elsSubAccount', 'name'],
    option: {
      isOption: true,
      dataValueProp: 'elsSubAccount',
      dataNameProp: 'name',
      valueProp: 'purchasePerson',
      nameProp: 'purchasePersonName',
      aliasProps: []
    }
  },
  {
    label: LABELS.purchaseManager,
    prop: 'responsible',
    url: '/masterdata/material/#/masterdata/view/',
    component: 'fast2-select-employee',
    func: 'saveSelected',
    params: ['responsible', 'responsibleName', 'elsSubAccount', 'name'],
    option: {
      isOption: true,
      dataValueProp: 'name',
      dataNameProp: 'name',
      valueProp: 'responsible',
      nameProp: '',
      aliasProps: []
    }
  },
  {
    label: LABELS.receiver,
    prop: 'receivedUser',
    url: '/masterdata/material/#/masterdata/view/',
    component: 'fast2-select-employee',
    func: 'saveSelected',
    params: ['receivedUser', 'receivedUserName', 'elsSubAccount', 'name']
  },
  {
    label: LABELS.purchaseManager,
    prop: 'purchaseInCharge',
    url: '/masterdata/material/#/masterdata/view/',
    component: 'fast2-select-employee',
    func: 'saveSelected',
    params: ['purchaseInCharge', 'purchaseInChargeName', 'elsSubAccount', 'name']
  },
  {
    label: LABELS.principal,
    prop: 'principal',
    url: '/masterdata/material/#/masterdata/view/',
    component: 'fast2-select-employee',
    func: 'saveSelected',
    params: ['principal', 'principalName', 'elsSubAccount', 'name']
  },
  {
    label: LABELS.salesManager,
    prop: 'salePerson',
    url: '/masterdata/material/#/masterdata/view/',
    component: 'fast2-select-employee',
    func: 'saveSelected',
    params: ['salePerson', 'salePersonName', 'elsSubAccount', 'name'],
    option: {
      isOption: true,
      dataValueProp: 'elsSubAccount',
      dataNameProp: 'name',
      valueProp: 'salePerson',
      nameProp: 'salePersonName',
      aliasProps: []
    }
  },
  {
    label: LABELS.applicant,
    prop: 'applicant',
    url: '/masterdata/material/#/masterdata/view/',
    component: 'fast2-select-employee',
    func: 'saveSelected',
    option: {
      isOption: true,
      dataValueProp: 'elsSubAccount',
      dataNameProp: 'name',
      valueProp: 'applicant',
      nameProp: '',
      aliasProps: []
    }
  },
  {
    label: LABELS.purchasingFactory,
    prop: 'purchaseFactory',
    url: '/masterdata/material/#/masterdata/view/',
    component: 'fast2-select-factory',
    func: 'saveSelected',
    params: ['purchaseFactory', 'purchaseFactoryName', 'orgId', 'orgDesc'],
    option: {
      isOption: true,
      dataValueProp: 'orgId',
      dataNameProp: 'orgDesc',
      valueProp: 'purchaseFactory',
      nameProp: 'purchaseFactoryName',
      aliasProps: []
    }
  },
  {
    label: LABELS.purchasingFactory,
    prop: 'factory',
    url: '/masterdata/material/#/masterdata/view/',
    component: 'fast2-select-factory',
    func: 'saveSelected',
    params: ['factory', 'factoryName', 'orgId', 'orgDesc']
  },
  {
    label: LABELS.applicationDepartment,
    prop: 'applyDept',
    url: '/masterdata/material/#/masterdata/view/',
    component: 'fast2-select-department',
    func: 'saveSelected',
    params: ['applyDept', 'applyDeptName', 'orgId', 'orgDesc']
  },
  {
    label: LABELS.organization,
    prop: 'orgId',
    url: '/masterdata/material/#/masterdata/view/',
    component: 'fast2-select-factory',
    func: 'saveSelected',
    params: ['orgId', 'orgDesc', 'orgId', 'orgDesc']
  },
  {
    label: LABELS.priceInformationRecordNumber,
    prop: 'priceRecordNumber',
    url: '/masterdata/material/#/masterdata/view/',
    component: 'fast2-select-price-record',
    func: 'saveSelected',
    params: ['priceRecordNumber', 'materialNumber', 'priceRecordNumber', 'materialNumber']
  },
  {
    label: LABELS.processingPlant,
    prop: 'factoryId',
    url: '/masterdata/material/#/masterdata/view/',
    component: 'fast2-select-factory',
    func: 'saveSelected',
    params: ['factoryId', 'factoryName', 'orgId', 'orgDesc']
  },
  {
    label: LABELS.deliveryNoticeOrder,
    prop: 'orderNumber',
    url: '/order/#/view/',
    component: 'fast2-select-order',
    func: 'saveSelectedAll',
    option: {
      isOption: true,
      dataValueProp: 'orderNumber',
      dataNameProp: '',
      valueProp: 'orderNumber',
      nameProp: '',
      aliasProps: []
    },
    params: []
  },
  {
    label: LABELS.outsourcingOrderNumber,
    prop: 'outOrderNumber',
    url: '/order/#/view/',
    component: 'fast2-select-order',
    func: 'saveSelected',
    params: ['outOrderNumber', 'outOrderItemNumber', 'orderNumber', 'orderItemNumber']
  },
  {
    label: LABELS.receipt,
    prop: 'voucherNumber',
    url: '/masterdata/material/#/masterdata/view/',
    component: 'fast2-select-voucher',
    func: 'saveSelected',
    option: {
      isOption: true,
      dataValueProp: 'deliveryNumber',
      dataNameProp: '',
      valueProp: 'voucherNumber',
      nameProp: '',
      aliasProps: []
    },
    params: []
  },
  {
    label: LABELS.deliveryNotice,
    prop: 'deliveryNoteNumber',
    url: '/masterdata/material/#/masterdata/view/',
    component: 'fast2-select-delivery',
    func: 'saveSelected',
    option: {
      isOption: true,
      dataValueProp: 'deliveryNoteNumber',
      dataNameProp: '',
      valueProp: 'deliveryNoteNumber',
      nameProp: '',
      aliasProps: []
    },
    params: []
  },
  {
    label: LABELS.reconciliations,
    prop: 'reconNumber',
    url: '/masterdata/material/#/masterdata/view/',
    component: 'fast2-select-recon',
    func: 'saveSelected',
    option: {
      isOption: true,
      dataValueProp: 'reconNumber',
      dataNameProp: '',
      valueProp: 'reconNumber',
      nameProp: '',
      aliasProps: []
    },
    params: []
  }
];

export default popList;
